import { Link } from 'react-router-dom';

const OnboardingSuccess = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-min-h-screen tw-bg-green-50 tw-p-6">
      <div className="tw-bg-white tw-rounded-xl tw-shadow-md tw-p-8 tw-text-center tw-max-w-md">
        <svg
          className="tw-w-12 tw-h-12 tw-text-green-500 tw-mx-auto"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
        <h1 className="tw-text-2xl tw-font-semibold tw-mt-4">Onboarding Successful</h1>
        <p className="tw-text-gray-600 tw-mt-2">
          Your Stripe onboarding has been completed. You can now receive payments.
        </p>
        <Link
          to="/"
          className="tw-inline-block tw-mt-6 tw-bg-green-500 tw-text-white tw-px-4 tw-py-2 tw-rounded hover:tw-bg-green-600"
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default OnboardingSuccess;
